import { axiosGet, axiosPost } from 'Redux/axiosHelper'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  GetAllEventsParams,
  PaginatedCommonEventResp,
  PaginatedEventsResp,
} from 'types/event/events'
import { PaginatedParams } from 'types/globalTypes'

// get events by different params
const getEvents = async (params: GetAllEventsParams) => {
  const response = await axiosGet(`v1/organization-events`, params)
  return response.data
}

export const useGetEvents = (params: GetAllEventsParams) => {
  const events = useQuery<PaginatedEventsResp>(
    ['all-events-by-params'],
    () => (params ? getEvents(params) : null),
    { enabled: false },
  )
  return events
}

const duplicateEvent = async (payload: {
  eventId: string
  newStartDate: string
}) => {
  const response = await axiosPost(
    payload,
    `v1/organization-events/duplicateEvent`,
  )
  return response.data
}

export const useDuplicateEvent = () => {
  const queryClient = useQueryClient()
  return useMutation(duplicateEvent, {
    onSuccess: data => {
      queryClient.setQueryData(
        ['common-event-listing'],
        (oldData: PaginatedCommonEventResp) => {
          if (!oldData)
            return {
              count: 1,
              records: [data],
              hasNextPage: false,
              hasPrevPage: false,
              totalPages: 1,
            }

          return {
            count: oldData.count + 1,
            records: [data, ...oldData.records],
            hasNextPage: oldData.hasNextPage,
            hasPrevPage: oldData.hasPrevPage,
            totalPages: oldData.totalPages + 1,
          }
        },
      )
    },
  })
}
